import React from "react";
import TwoColumn from "../../../../Components/TwoColumn";
import Img from "../../../../assets/images/image";
import WhatMakesUsDifferent from "../../../../Components/WhatMakesUsDifferent";
import GetInTouch from "../../../../Components/GetInTouch";
import { data } from "../../../../Data/data";
import { Helmet } from "react-helmet";
import HeroSection from "../../../../Components/HeroSection/HeroSection";

export default function WebDevelopment() {
   // const sectionStyle = { minHeight: "75vh", paddingTop: "20px", paddingBottom: "20px" };
   return (
      <div className="animation fadeIn">
         <Helmet>
            <title>Establish your website with the best web development services</title>
            <meta
               name="description"
               content="Looking for top-notch web development services in India? Witmates Technologies delivers excellent website designs tailored to your needs."
            />
           <link rel="canonical" href=" https://www.witmates.com/services/project-development/web_app" /> 
         </Helmet>
         <div>
            <HeroSection
               image={Img.webAppBg}
               heading={
                  <>
                     We Create{" "}
                     <span className="witmates-theme-color">
                        Progressive <br />
                     </span>{" "}
                     with Superior <span className="witmates-theme-color">superior functionalities</span>
                  </>
               }
               description={<>We craft seamless web development services that deliver outstanding functionalities and exceptional user experiences. </>}
               link
            />
            <div id="contentMarketing" className="pt100 mobPt50 d-flex justify-content-center align-items-center">
               <TwoColumn
                  image={Img.frontendDev}
                  heading={
                     <>
                        Front End <br /> Development
                     </>
                  }
                  pageName="Front end"
                  buttonName="BUILD TOGETHER"
                  redirection="/get-in-touch"
                  subPoints={["HTML", "CSS", "VueJS", "ReactJS", "Angular", "Web3JS"]}
                  isZoom={true}
                  description={
                     <>
                        At Witmates, we create visually stunning and interactive websites that captivate your audience. Our talented team of front-end developers combines cutting-edge technologies,
                        creative design, and seamless functionality to deliver exceptional user experiences by providing web development services.
                        <br />
                        With our front-end expertise, we ensure that your website is not only aesthetically pleasing but also intuitive and user-friendly. We design the user interface, focusing on
                        responsive layouts, smooth navigation, and engaging interactions using modern frameworks and libraries.
                        <br />
                        Leveraging the latest industry standards and best practices, we create dynamic and interactive web experiences that leave a lasting impact on your visitors.
                        <br />
                        From crafting visually appealing landing pages to developing complex web applications, our front-end solutions are tailored to your specific business needs.
                        <br />
                        We collaborate closely with you to understand your goals, brand identity, and target audience, ensuring that every element of the front-end design aligns seamlessly with your
                        overall vision.
                        <br />
                        Together, let's create a compelling digital experience that sets your website apart, engages your users, and drives your business forward.
                     </>
                  }
               />
            </div>
            <div id="contentMarketing" className="d-flex justify-content-center align-items-center pt100 pb100 mobPb50">
               <TwoColumn
                  reverse
                  image={Img.backendDev}
                  heading={
                     <>
                        Back End <br /> Development
                     </>
                  }
                  pageName="back end"
                  buttonName="BUILD TOGETHER"
                  redirection="/get-in-touch"
                  subPoints={["Ruby on Rails", "Java", "Express.js", "Typescript", "Django"]}
                  isZoom={true}
                  description={
                     <>
                        We specialize in backend web development services, the engine that powers your website's functionality and performance. Our skilled team of backend developers ensures that your
                        website operates seamlessly, handles data efficiently, and delivers a secure and reliable experience for your users.
                        <br />
                        Behind every successful website, there is a robust backend infrastructure. Our backend development services focus on creating scalable and efficient systems that support your
                        website's features and functionalities.
                        <br />
                        With our deep understanding of backend technologies, we integrate third-party APIs, develop custom content management systems (CMS), and implement secure user authentication
                        systems to enhance the functionality and user experience of your website.
                        <br />
                        Our team conducts thorough testing and optimization to maximize your website's speed and responsiveness.
                        <br />
                        Whether you require a robust e-commerce platform, a content-rich website, or a custom web application,  Our backend web development services focus on creating scalable and efficient systems that support your website's features and functionalities.
                        <br />
                        Partner with us to leverage the power of backend technologies and empower your website with reliability, efficiency, and seamless functionality.
                     </>
                  }
               />
            </div>

            <WhatMakesUsDifferent data={data.webDevelopmentData} height="315px" />
            <GetInTouch />
         </div>
      </div>
   );
}
